import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { client, urlFor } from "../../client";
import "./AllBlogs.scss";
import { AppWrap } from "../../wrapper";
import { DotLoader } from "react-spinners";
import QuickLinks from "../Footer/QuickLinks";

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 8;
  const [totalBlogs, setTotalBlogs] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    const start = (currentPage - 1) * blogsPerPage;
    const end = start + blogsPerPage;
    const query = `*[_type == "blog"] | order(publishedAt desc) [${start}...${end}]{..., category[]->}`;
    const countQuery = 'count(*[_type == "blog"])';
    const categoryQuery =
      '*[_type == "category"]{title, slug, "count": count(*[_type == "blog" && references(^._id)])} | order(count desc)[0...4]';

    Promise.all([
      client.fetch(query),
      client.fetch(countQuery),
      client.fetch(categoryQuery),
    ]).then(([blogData, blogCount, categoryData]) => {
      setBlogs(blogData);
      setTotalBlogs(blogCount);
      setCategories(categoryData);
      setLoading(false);
    });
  }, [currentPage]);

  // Pagination controls
  const totalPages = Math.ceil(totalBlogs / blogsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setLoading(true);
      setCurrentPage(page);
    }
  };

  return (
    <div className="app__all-blogs">
      <h2 className="head-text">
        All <span>Blogs</span>
      </h2>

      {/* Categories Section */}
      <div className="categories-section">
        <h3>Categories</h3>
        <div className="categories-list">
          {categories.map((cat, idx) => (
            <Link
              to={`/categories/${cat.slug?.current || cat.title}`}
              className="category-item"
              style={{ textDecoration: "none" }}
              key={cat.slug?.current || cat.title}
            >
              <span className="category-title">{cat.title}</span>
              <span className="category-count">{cat.count}</span>
            </Link>
          ))}
          <div className="show-all-categories">
            <Link to="/categories">Show All</Link>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <DotLoader color="#3498db" size={50} />
        </div>
      ) : (
        <>
          <div className="app__all-blogs-container">
            {blogs.map((blog, index) => (
              <div
                className="app__all-blog-item"
                key={blog.slug.current + index}
              >
                <Link to={`/blogs/${blog.slug.current}`} className="blog-link">
                  <img src={urlFor(blog.mainImage)} alt={blog.title} />
                  <h3 className="bold-text">{blog.title}</h3>
                  <p className="p-text">{blog.description}</p>
                  {blog.category && blog.category.length > 0 && (
                    <div className="blog-categories-list">
                      {blog.category.map((cat, i) => (
                        <Link
                          to={`/categories/${cat.slug?.current || cat.title}`}
                          className="blog-category-badge"
                          style={{ textDecoration: "none" }}
                          key={cat._id || i}
                        >
                          {cat.title}
                        </Link>
                      ))}
                    </div>
                  )}
                  <p
                    className="p-text"
                    style={{ marginTop: 10, color: "#6b7688" }}
                  >
                    Published on:{" "}
                    {new Date(blog.publishedAt).toLocaleDateString()}
                  </p>
                </Link>
              </div>
            ))}
          </div>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i + 1}
                  className={currentPage === i + 1 ? "active" : ""}
                  onClick={() => handlePageChange(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
      <QuickLinks />
    </div>
  );
};

export default AppWrap(AllBlogs, "allblogs");
